function config($translateProvider, localeFormat) {
  const defaultLocale = 'en_US';

  const locale = localeFormat.formatLocaleString(
    // eslint-disable-next-line angular/document-service
    (window.document.getElementById('og-msi') || window.document.documentElement).getAttribute('og-locale')
  );

  const availableTranslations = $translateProvider.translations();

  $translateProvider.useSanitizeValueStrategy('escaped', 'sanitizeParameters');

  if (locale && availableTranslations[locale]) {
    $translateProvider.use(locale);
  }
  else {
    $translateProvider.use(defaultLocale);
  }
}

config.$inject = ['$translateProvider', 'localeFormat'];

module.exports = config;
